export default new URL("../images/panel.jpg", import.meta.url).href;